/* tslint:disable */

declare var Object: any;
export interface ERPproformaInvoiceInterface {
  "id"?: number;
}

export class ERPproformaInvoice implements ERPproformaInvoiceInterface {
  "id": number;
  constructor(data?: ERPproformaInvoiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPproformaInvoice`.
   */
  public static getModelName() {
    return "ERPproformaInvoice";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPproformaInvoice for dynamic purposes.
  **/
  public static factory(data: ERPproformaInvoiceInterface): ERPproformaInvoice{
    return new ERPproformaInvoice(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPproformaInvoice',
      plural: 'ERPproformaInvoices',
      path: 'ERPproformaInvoices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPproformaInvoice.ts